import type { useWindowDimensionsInterface } from "@dealer-center/core-custom-components";

export * from "./page-template";

export const shouldPinLinksMenu = (
  windowDimensions: useWindowDimensionsInterface
) => windowDimensions.is4xlOrGreater;
